import { render, staticRenderFns } from "./DuplicateDeliverableListItem.vue?vue&type=template&id=50054075&scoped=true&"
import script from "./DuplicateDeliverableListItem.vue?vue&type=script&lang=js&"
export * from "./DuplicateDeliverableListItem.vue?vue&type=script&lang=js&"
import style0 from "./DuplicateDeliverableListItem.vue?vue&type=style&index=0&id=50054075&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50054075",
  null
  
)

export default component.exports